import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent } from "../components/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import * as ROUTES from "../utils/routes";
import { Link } from "react-router-dom";

const styles = theme => ({
  contentContainer: {
    textAlign: "Left",
  }
});

export const AddDeviceDialog = withStyles(styles)(({ onClose, classes }) => (
  <Dialog maxWidth="sm" fullWidth={true} scroll="body" open spacing={0} onClose={event =>{event.stopPropagation(); onClose();}} onClick={event =>event.stopPropagation()}>

    <DialogContent>
      <div className={classes.contentContainer}>
        <p>To register a new device, you must run the Mighty MDM Installer with the device plugged into your computer.</p>
        <p>See the "<Link to={ROUTES.DASHBOARD}>Register a Device</Link>" section of the documentation for more instructions.</p>
      </div>
    </DialogContent>
  </Dialog>
));
